import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { SegmentOption } from './segmented-radio.models';

@Component({
  selector: 'app-segmented-radio',
  imports: [],
  templateUrl: './segmented-radio.component.html',
  styleUrl: './segmented-radio.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentedRadioComponent {
  options = input.required<SegmentOption[]>();
  name = input.required<string>();
  idPrefix = input.required<string>();

  value = model<string>('');
}
